const PREFIX = 'SIGNUP_POPUP_';
export const SIGNUP_POPUP_HIDE_ERROR = `${PREFIX}HIDE_ERROR`;
export const hideError = () => ({
  type: SIGNUP_POPUP_HIDE_ERROR
});